import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { Size } from "yfiles";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "graph";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NODE_MIN_SIZE = new Size(180, 65);
export const NODE_MAX_SIZE = new Size(250, 100);
export const NODE_ROUND_RADIUS = 10;
export const NODE_GROUP_MIN_SIZE = new Size(240, 220);
export const NODE_GROUP_MAX_SIZE = new Size(450, 500);
export const NODE_GROUP_MAX_VISIBLE_ROWS_COUNT = 15;
export const NODE_GROUP_HEADER_HEIGHT = 30;
export const ZOOM = {
    MIN: 0.05,
    MAX: 2,
    DEFAULT: 1,
    NAVIGATE_TO_MAX: 1,
    NAVIGATE_TO_MIN: 0.6
};
const COMMAND_ATTR = "data-graph-command";
export const undoButtonAttrs = { [COMMAND_ATTR]: "Undo" };
export const redoButtonAttrs = { [COMMAND_ATTR]: "Redo" };
export const undoSelector = `[${COMMAND_ATTR}='Undo']`;
export const redoSelector = `[${COMMAND_ATTR}='Redo']`;
export const GRAPH_IN_PROGRESS_CLASS_NAME = "graph-in-progress";
export const GRAPH_IS_EXPORTING_CLASS_NAME = "graph-in-progress";
export const GRAPH_IN_PRESENTATION_MODE_CLASS_NAME = "graph-in-presentation-mode";
export const UNDO_ENGINE_AUTO_MERGE_TIME = 300;
export const DETAILS_THRESHOLD_ZOOM_LEVEL = 0.65;
export const INTERMEDIATE_THRESHOLD_ZOOM_LEVEL = 0.4;
export const localStorageCopyGraphKey = "ohotnik.graph.clipboard";
export const HIGHLIGHT_NODES_DELAY = 4000;
